module.exports = __webpack_public_path__ + "img/twitter.6620c8ae.svg";